import addServiceCategory from "app/api/requests/ServiceCategories/addServiceCategoryRequest";
import delServiceCategory from "app/api/requests/ServiceCategories/delServiceCategoryRequest";
import editServiceCategory from "app/api/requests/ServiceCategories/editServiceCategoryRequest";
import getServiceCategories from "app/api/requests/ServiceCategories/getServiceCategoriesRequest";

export default {
  addServiceCategory,
  delServiceCategory,
  editServiceCategory,
  getServiceCategories
};
